import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { Routes, RouterModule } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth-layout/auth-layout.component";
import { AuthGuard } from "./auth/auth.guard";

import { UnguardedBreezeReportComponent } from "./layouts/unguarded-breeze-report/unguarded-breeze-report.component";

const routes: Routes = [
  {
    path: "",
    component: UnguardedBreezeReportComponent,
    children: [
      {
        path: "",
        loadChildren:
          "./layouts/unguarded-breeze-report/unguarded-breeze-report.module#UnGuardedBreezeReport",
      },
    ],
  },
  {
    path: "",
    // component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: "./landing/landing.module#LandingModule",
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: "./auth/auth.module#AuthModule",
      },
    ],
  },
  {
    path: "",
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        loadChildren:
          "./layouts/admin-layout/admin-layout.module#AdminLayoutModule",
        canLoad: [AuthGuard],
      },
    ],
  },
  {
    path: "",
    component: AuthLayoutComponent,
    children: [
      {
        path: "",
        loadChildren:
          "./layouts/auth-layout/auth-layout.module#AuthLayoutModule",
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes, {
      useHash: true,
    }),
  ],
  exports: [],
})
export class AppRoutingModule {}
